import { get, post, formatPublicParams, prefix } from '../index';
import { getDomainBaseUrl } from '@ugc-utils/domains';

const getQuestionList = (productId, params = {}) =>
  get(`${getDomainBaseUrl('catalog')}${prefix}/api/product/${productId}/question/search`, params);

const getQuestionAnswers = (productId, questionId = '', page = 1, limit = 10, sortId = 4) =>
  get(
    `${getDomainBaseUrl('catalog')}${prefix}/api/product/${productId}/question/v2/${questionId}/answer`,
    formatPublicParams({ limit, sortId, npt: page })
  );

const getCategory = language =>
  get(`${getDomainBaseUrl('catalog')}${prefix}/api/question/category`, { languageCode: language });

const getSorterV2 = language =>
  get(`${getDomainBaseUrl('catalog')}${prefix}/api/question/sorter/v2`, { languageCode: language });

const getCanPostQuestion = () => get(`${getDomainBaseUrl('catalog')}${prefix}/api/customer/canPostQuestion`);

const getCanPostAnswer = ({ pid, qid }): any =>
  get(`${getDomainBaseUrl('catalog')}${prefix}/api/product/${pid}/question/${qid}/canPostAnswer`);

const postHelpful = ({ pid, qid, aid, isHelpful }) =>
  post(
    `${getDomainBaseUrl('catalog')}${prefix}/api/product/${pid}/question/${qid}/answer/${aid}/helpful`,
    {
      response: isHelpful,
    },
    {
      headers: { Accept: 'application/json' },
    }
  );

const postQuestion = ({ productId, categoryId, content }) =>
  post(
    `${getDomainBaseUrl('catalog')}${prefix}/api/product/${productId}/question`,
    formatPublicParams({ categoryId, content })
  );

const postAnswer = ({ productId, content, qid }) =>
  post(
    `${getDomainBaseUrl('catalog')}${prefix}/api/product/${productId}/question/${qid}/answer`,
    formatPublicParams({ content })
  );

const postSeeMoreAnswersMetrics = questionId =>
  post(`${getDomainBaseUrl('catalog')}${prefix}/api/question/${questionId}/metrics/see-more-answers`);

const getAnswered = (questionIds: string[]) =>
  post(`${getDomainBaseUrl('catalog')}${prefix}/api/answer/question/answered`, questionIds, {}, false);

export {
  getQuestionList,
  getQuestionAnswers,
  getCategory,
  getSorterV2,
  getCanPostQuestion,
  getCanPostAnswer,
  postHelpful,
  postQuestion,
  postAnswer,
  postSeeMoreAnswersMetrics,
  getAnswered,
};
